import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ClipboardService } from 'ngx-clipboard';

@Component({
  selector: 'app-citacao-modal',
  templateUrl: './citacao-modal.component.html',
  styleUrls: ['./citacao-modal.component.scss']
})
export class CitacaoModalComponent implements OnInit {

  constructor(
    public modalService: NgbModal,
    private clipboardService: ClipboardService,
  ) { }

  @Input() data: string;
  @Input() citacao: string;
  @Input() linkSite: string;

  isActive = false;


  @ViewChild('content') content!: TemplateRef<any>;

  ngOnInit(): void {
  }

  open() {
    this.modalService.open(this.content, { centered: true });
  }

  copiarTexto() {
    const texto = `${this.citacao} ${this.linkSite}. Acesso em: ${this.data}.`;
    this.clipboardService.copy(texto);
    this.isActive = true;
    setTimeout(() => {
      this.isActive = false;
    }, 1000);
  }

}
